import Request from './request';

export default class PaymentHttpService {
    private static uri = 'payments';

    public static listPaymentMethods() {
        return Request.get(`${this.uri}`);
    }
}
